<template>
  <div class="activity">
    <h2>Activity id: {{ $route.params.id }}</h2>

    <h4>Title: {{ activity.Title }}</h4>
  </div>
</template>
<script>
import * as API from "./../../api";

export default {
  name: "ActivityDetail",
  methods: {
    getActivity() {
      this.$api
        .get(API.endpoints.activities + "/" + this.$route.params.id)
        .then((response) => {
          this.activity = response.data;
        })
        .catch((error) => {
          this.$notify({
            title: "Error",
            message: error,
            type: "danger",
          });
        });
    },
  },
  data() {
    return {
      activity: [],
    };
  },
  mounted() {
    this.getActivity();
  },
};
</script>
